import React, { useState } from "react";

import CreateJobForm from "../components/job/JobCreateForm";
import PageContainer from "../components/shared/PageContainer";
import { Job } from "../services/api";

function JobCreate() {
  const prefill = {
    _id: "",
    source: "https://d3b9yaqsrvahou.cloudfront.net/CrayolaAd.mp4",
    session_id: "38-1",
    name: "TestAd_5s_A",
    network_id: "88881",
    source_creative_rendition_id: 888811201,
    content_type: "video/peacock-atp",
    creative_rendition_id_key: "TIT2",
    creative_rendition_id_value: "fw_888811201",
  };
  const [newJob, setNewJob] = useState(new Job(prefill as any));

  return (
    <PageContainer>
      <CreateJobForm newJob={newJob} setNewJob={setNewJob} />
    </PageContainer>
  );
}

export default JobCreate;
